/*
 * Copyright (c) 2022 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import {
    DeviceDetailsDto,
    FirmwareHistoryListDto,
    OperatorHistoryListDto,
    RegistrationHistoryItemDto,
    StatusHistoryListDto,
} from '../api/devices/devicesClient.typing';
import { DeviceDetailsAction, DeviceDetailsActionType } from '../actions/deviceDetailsActions';

export interface DeviceDetailsState {
    deviceDetails: DeviceDetailsDto;
    firmwareHistory: FirmwareHistoryListDto;
    statusHistory: StatusHistoryListDto;
    operatorHistory: OperatorHistoryListDto;
    registrationHistory: RegistrationHistoryItemDto[];
    isLoading: boolean;
    isLoadingFirmwareHistory: boolean;
    isLoadingStatusHistory: boolean;
    isLoadingOperatorHistory: boolean;
    isLoadingRegistrationHistory: boolean;
    currentHistoryTab: number;
}

const initialState: DeviceDetailsState = {
    deviceDetails: null,
    firmwareHistory: null,
    statusHistory: null,
    operatorHistory: null,
    registrationHistory: null,

    isLoading: false,
    isLoadingFirmwareHistory: false,
    isLoadingStatusHistory: false,
    isLoadingOperatorHistory: false,
    isLoadingRegistrationHistory: false,

    currentHistoryTab: 0,
};

export function deviceDetailsReducer(
    state: DeviceDetailsState = initialState,
    action: DeviceDetailsAction,
): DeviceDetailsState {
    switch (action.type) {
        case DeviceDetailsActionType.OPEN_REGISTRY_DEVICE_CARD_PAGE:
            return {
                ...state,
                isLoading: true,
            };

        case DeviceDetailsActionType.FETCH_DEVICE_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                deviceDetails: action.payload,
            };

        case DeviceDetailsActionType.FETCH_DEVICE_DETAILS_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case DeviceDetailsActionType.FETCH_FIRMWARE_HISTORY:
            return {
                ...state,
                isLoadingFirmwareHistory: true,
            };

        case DeviceDetailsActionType.FETCH_FIRMWARE_HISTORY_SUCCESS:
            return {
                ...state,
                isLoadingFirmwareHistory: false,
                firmwareHistory: action.payload,
            };

        case DeviceDetailsActionType.FETCH_FIRMWARE_HISTORY_ERROR:
            return {
                ...state,
                isLoadingFirmwareHistory: false,
                firmwareHistory: {
                    count: 0,
                    items: [],
                },
            };

        case DeviceDetailsActionType.DOWNLOAD_FIRMWARE_HISTORY:
            return {
                ...state,
                isLoadingFirmwareHistory: true,
            };

        case DeviceDetailsActionType.DOWNLOAD_FIRMWARE_HISTORY_SUCCESS:
        case DeviceDetailsActionType.DOWNLOAD_FIRMWARE_HISTORY_ERROR:
            return {
                ...state,
                isLoadingFirmwareHistory: false,
            };

        case DeviceDetailsActionType.FETCH_STATUS_HISTORY:
            return {
                ...state,
                isLoadingStatusHistory: true,
            };

        case DeviceDetailsActionType.FETCH_STATUS_HISTORY_SUCCESS:
            return {
                ...state,
                isLoadingStatusHistory: false,
                statusHistory: action.payload,
            };

        case DeviceDetailsActionType.FETCH_STATUS_HISTORY_ERROR:
            return {
                ...state,
                isLoadingStatusHistory: false,
                statusHistory: {
                    count: 0,
                    items: [],
                },
            };

        case DeviceDetailsActionType.DOWNLOAD_STATUS_HISTORY:
            return {
                ...state,
                isLoadingStatusHistory: true,
            };

        case DeviceDetailsActionType.DOWNLOAD_STATUS_HISTORY_SUCCESS:
        case DeviceDetailsActionType.DOWNLOAD_STATUS_HISTORY_ERROR:
            return {
                ...state,
                isLoadingStatusHistory: false,
            };

        case DeviceDetailsActionType.FETCH_OPERATOR_HISTORY:
            return {
                ...state,
                isLoadingOperatorHistory: true,
            };

        case DeviceDetailsActionType.FETCH_OPERATOR_HISTORY_SUCCESS:
            return {
                ...state,
                isLoadingOperatorHistory: false,
                operatorHistory: action.payload,
            };

        case DeviceDetailsActionType.FETCH_OPERATOR_HISTORY_ERROR:
            return {
                ...state,
                isLoadingOperatorHistory: false,
                operatorHistory: {
                    count: 0,
                    items: [],
                },
            };

        case DeviceDetailsActionType.DOWNLOAD_OPERATOR_HISTORY:
            return {
                ...state,
                isLoadingOperatorHistory: true,
            };

        case DeviceDetailsActionType.DOWNLOAD_OPERATOR_HISTORY_SUCCESS:
        case DeviceDetailsActionType.DOWNLOAD_OPERATOR_HISTORY_ERROR:
            return {
                ...state,
                isLoadingOperatorHistory: false,
            };

        case DeviceDetailsActionType.FETCH_REGISTRATION_HISTORY:
            return {
                ...state,
                isLoadingRegistrationHistory: true,
            };

        case DeviceDetailsActionType.FETCH_REGISTRATION_HISTORY_SUCCESS:
            return {
                ...state,
                isLoadingRegistrationHistory: false,
                registrationHistory: action.payload,
            };

        case DeviceDetailsActionType.FETCH_REGISTRATION_HISTORY_ERROR:
            return {
                ...state,
                isLoadingRegistrationHistory: false,
                registrationHistory: [],
            };

        case DeviceDetailsActionType.DOWNLOAD_REGISTRATION_HISTORY:
            return {
                ...state,
                isLoadingRegistrationHistory: true,
            };

        case DeviceDetailsActionType.DOWNLOAD_REGISTRATION_HISTORY_SUCCESS:
        case DeviceDetailsActionType.DOWNLOAD_REGISTRATION_HISTORY_ERROR:
            return {
                ...state,
                isLoadingRegistrationHistory: false,
            };
        case DeviceDetailsActionType.CHANGE_HISTORY_TAB:
            return {
                ...state,
                currentHistoryTab: action.payload,
            };

        case DeviceDetailsActionType.EXIT_REGISTRY_DEVICE_CARD_PAGE:
            return {
                ...state,
                deviceDetails: null,
                firmwareHistory: null,
                statusHistory: null,
                operatorHistory: null,
                registrationHistory: null,
                currentHistoryTab: 0,
            };

        default:
            break;
    }

    return state;
}
